import { render, staticRenderFns } from "./MerchantPaymentList.vue?vue&type=template&id=988dd42c&scoped=true"
import script from "./MerchantPaymentList.vue?vue&type=script&lang=js"
export * from "./MerchantPaymentList.vue?vue&type=script&lang=js"
import style0 from "./MerchantPaymentList.vue?vue&type=style&index=0&id=988dd42c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988dd42c",
  null
  
)

export default component.exports